import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12.043c0 .34-.06.667-.171.969l-.01.026v-1.99c.117.309.181.644.181.995",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.82 11.047h-2.035v1.991h2.034z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".783",
      d: "M22 12.043a8.043 8.043 0 0 1-16.085 0m16.085 0a8.043 8.043 0 0 0-16.085 0m16.085 0a4.81 4.81 0 1 1-9.62 0m9.62 0a4.81 4.81 0 1 0-9.62 0m9.62 0c0-.35-.064-.686-.18-.996m.18.996c0 .34-.06.667-.171.969m.171-.97c0-.389-.079-.76-.221-1.097M5.915 12.043h13.49m-13.49 0h6.465m0 0h3.982m2.82 2.818a2.82 2.82 0 0 1-2.82-2.818m2.82 2.818a2.82 2.82 0 0 0 2.637-1.823m-2.638 1.823a2.82 2.82 0 0 0 2.648-1.85m-5.467-.968a2.819 2.819 0 0 1 5.417-1.098m.04.102h-2.034v1.991h2.034m0-1.99v1.99m0-1.99-.04-.103m.04 2.093.01-.026M2 11.047h1.991v1.991H2z"
    }, null, -1)
  ])))
}
export default { render: render }